<div class="payment-create">
  <div class="page-header">
    <button mat-icon-button [routerLink]="['/rentals', rentalId]" *ngIf="rentalId" aria-label="Назад">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <button mat-icon-button routerLink="/rentals" *ngIf="!rentalId" aria-label="Назад">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1 class="page-title">Новый платёж</h1>
  </div>

  <mat-card *ngIf="!rentalId" class="no-rental-card">
    <mat-card-content>
      <p>Прокат не указан. Откройте форму создания платежа со страницы проката.</p>
      <button mat-raised-button color="primary" routerLink="/rentals" class="full-width-btn">
        <mat-icon>list</mat-icon> К списку прокатов
      </button>
    </mat-card-content>
  </mat-card>

  <ng-container *ngIf="rentalId">
    <mat-card class="payment-info-card">
      <mat-card-content>
        <div class="info-row">
          <mat-icon>directions_car</mat-icon>
          <span>Прокат #{{ rentalId }}</span>
        </div>
      </mat-card-content>
    </mat-card>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="payment-form">
      <mat-card class="form-card">
        <mat-card-content>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Сумма</mat-label>
            <input matInput type="number" formControlName="amount" min="0.01" step="0.01" required>
            <mat-error *ngIf="form.get('amount')?.hasError('required')">Укажите сумму</mat-error>
            <mat-error *ngIf="form.get('amount')?.hasError('min')">Сумма должна быть больше 0</mat-error>
            <mat-error *ngIf="form.get('amount')?.hasError('serverError')">{{ form.get('amount')?.getError('serverError') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Способ оплаты</mat-label>
            <mat-select formControlName="paymentMethod" required>
              <mat-option *ngFor="let opt of paymentMethodOptions" [value]="opt.value">{{ opt.label }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('paymentMethod')?.hasError('required')">Выберите способ оплаты</mat-error>
            <mat-error *ngIf="form.get('paymentMethod')?.hasError('serverError')">{{ form.get('paymentMethod')?.getError('serverError') }}</mat-error>
          </mat-form-field>

          <mat-checkbox formControlName="isPaid" class="full-width">Оплачен</mat-checkbox>

          <app-datetime-input
            formControlName="paymentDate"
            dateLabel="Дата оплаты"
            timeLabel="Время">
          </app-datetime-input>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Описание</mat-label>
            <textarea matInput formControlName="description" rows="3"></textarea>
          </mat-form-field>
        </mat-card-content>
      </mat-card>

      <button mat-raised-button color="primary" type="submit" class="full-width-btn submit-btn"
              [disabled]="form.invalid || submitting">
        <mat-spinner *ngIf="submitting" diameter="20" class="btn-spinner"></mat-spinner>
        <span *ngIf="!submitting"><mat-icon>save</mat-icon> Создать платёж</span>
      </button>
    </form>
  </ng-container>
</div>
